import { render, staticRenderFns } from "./complaintManage.vue?vue&type=template&id=89541a5c"
import script from "./complaintManage.vue?vue&type=script&lang=js"
export * from "./complaintManage.vue?vue&type=script&lang=js"
import style0 from "./complaintManage.vue?vue&type=style&index=0&id=89541a5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports